<template>
    <BreadCrumb PageTitle="Soumission d'un BESC" />
    <PageSoumissionBesc />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PageSoumissionBesc from "@/components/BESC/PageSoumissionBesc.vue";
  
    export default defineComponent({
      name: "PageSoumissionBescPage",
      components: {
        BreadCrumb,
        PageSoumissionBesc,
      },
    });
  </script>